import React from 'react';
import Exam_Timetable from './Exam_Timetable';
import '../../../CommonCSS/SocietyCSS.css'

const Exam_TimetableApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Exam Timetable</h5>
          </div>  
        </div>
        <Exam_Timetable/>
      </div>
    </div >
  );
};

export default Exam_TimetableApp;
